import { moduleRunStatusData, transformApiDataToModuleStatus } from "./moduleRunStatusData";

export const getEdgeData = (apiData) => {
    const edgeData = transformApiDataToModuleStatus(apiData);

    const edges = [
    { 
        id: 'fgs-dom',
        source: 'fgs',
        target: 'dom',
        data: {...edgeData.edgeDetails["fgs-dom"]},
        type: 'customEdge',
    },
    { 
        id: 'fgs-do',
        source: 'fgs', 
        target: 'do', 
        data: {...edgeData.edgeDetails["fgs-do"]},
        type: 'customEdge', 
        targetHandle: "a"
    },
    { 
        id: 'dom-do', 
        source: 'dom', 
        target: 'do', 
        data: {...edgeData.edgeDetails["dom-do"]},
        type: 'customEdge', 
        targetHandle: "b"
    },
    { 
        id: 'do-rdp', 
        source: 'do', 
        target: 'rdp', 
        data: {...edgeData.edgeDetails["do-rdp"]},
        type: 'customEdge',
    },
    { 
        id: 'rdp-cp', 
        source: 'rdp', 
        target: 'cp', 
        data: {...edgeData.edgeDetails["rdp-cp"]},
        type: 'customEdge',
    },
    { 
        id: 'rdp-ff', 
        source: 'rdp', 
        target: 'ff', 
        data: {...edgeData.edgeDetails["rdp-ff"]},
        type: 'customEdge',
    },
    { 
        id: 'poos-do', 
        source: 'poos', 
        target: 'do', 
        data: {...edgeData.edgeDetails["poos-do"]},
        type: 'customEdge',
    },
    { 
        id: 'poos-slp', 
        source: 'poos', 
        target: 'slp', 
        data: {...edgeData.edgeDetails["poos-slp"]},
        type: 'customEdge',
    },
    {
        id: 'slp-iof', 
        source: 'slp', 
        target: 'iof', 
        data: {...edgeData.edgeDetails["slp-iof"]},
        type: 'customEdge', 
    },
    {
        id: 'rr-fgs', 
        source: 'rr', 
        target: 'fgs', 
        data: {...edgeData.edgeDetails["rr-fgs"]},
        type: 'customEdge', 
    },
    {
        id: 'poos-erm', 
        source: 'poos', 
        target: 'erm', 
        data: {...edgeData.edgeDetails["poos-erm"]},
        type: 'customEdge', 
    },
    {
        id: 'cp-nps', 
        source: 'cp', 
        target: 'nps', 
        data: {...edgeData.edgeDetails["cp-nps"]},
        type: 'customEdge', 
    },
    {
        id: 'cp-do', 
        source: 'cp', 
        target: 'do', 
        data: {...edgeData.edgeDetails["cp-do"]},
        type: 'customEdge', 
    }
];
return edges;
};

export const edges = [
    { 
        id: 'fgs-dom',
        source: 'fgs',
        target: 'dom',
        data: {...moduleRunStatusData.edgeDetails["fgs-dom"]},
        type: 'customEdge',
    },
    { 
        id: 'fgs-do',
        source: 'fgs', 
        target: 'do', 
        data: {...moduleRunStatusData.edgeDetails["fgs-do"]},
        type: 'customEdge', 
        targetHandle: "a"
    },
    { 
        id: 'dom-do', 
        source: 'dom', 
        target: 'do', 
        data: {...moduleRunStatusData.edgeDetails["dom-do"]},
        type: 'customEdge', 
        targetHandle: "b"
    },
    { 
        id: 'do-rdp', 
        source: 'do', 
        target: 'rdp', 
        data: {...moduleRunStatusData.edgeDetails["do-rdp"]},
        type: 'customEdge',
    },
    { 
        id: 'rdp-cp', 
        source: 'rdp', 
        target: 'cp', 
        data: {...moduleRunStatusData.edgeDetails["rdp-cp"]},
        type: 'customEdge',
    },
    { 
        id: 'rdp-ff', 
        source: 'rdp', 
        target: 'ff', 
        data: {...moduleRunStatusData.edgeDetails["rdp-ff"]},
        type: 'customEdge',
    },
];
 
